// There are much more categories in the backend.
// This enum kept those categories that the ui depends on

export enum ItemCategories {
    shoes = 'b265e713-a2ef-469e-ad64-1bbd669fc6f0',
}
